import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { BsInbox } from 'react-icons/bs';
import { MdError } from 'react-icons/md';
import { Tab, Container, Button, ButtonGroup } from 'react-bootstrap';
import * as api from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';
import { getToday } from '~/Utils/Helpers';
import Aviso from '~/Components/Aviso';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import FiltrosInadimplencia from '~/Components/Inadimplencia/FiltrosInadimplencia';
import TabelaInadimplencia from '~/Components/Inadimplencia/TabelaInadimplencia';
import EstatisticasInadimplencia from '~/Components/Inadimplencia/EstatisticasInadimplencia';
import ModalDetalhesClienteInadimplencias from '~/Components/Inadimplencia/ModalDetalhesClienteInadimplencias';

const CobrancaInadimplencia = ({
  empreendimentos,
  imobiliarias,
  corretores,
  isLoadingOptions,
}) => {
  const [registros, setRegistros] = useState([]);
  const [erroBuscaInadimpencias, setErroBuscaInadimpencias] = useState(false);
  const [carregandoInadimplencias, setCarregandoInadimplencias] = useState(
    false
  );
  const [registroSelecionado, setRegistroSelecionado] = useState(null);
  const [abaAtiva, setAbaAtiva] = useState('analitico');

  useEffect(() => {
    const filtros = {
      data_inicial: getToday().add(-90, 'days'),
      data_final: getToday(),
    };
    buscarListaInadimplencias(AuthStorage.isCorretor() ? {} : filtros);

    const abaSession = sessionStorage.getItem('inadimplenciaAbaAtiva');
    if (abaSession) {
      setAbaAtiva(abaSession);
    }
  }, []);

  const handleAbaChange = aba => {
    setAbaAtiva(aba);
    sessionStorage.setItem('inadimplenciaAbaAtiva', aba);
  };

  const toArrayObjetos = columsRowsData => {
    const array = [];
    for (const row of columsRowsData.rows) {
      const obj = {};
      for (let index = 0; index < row.length; index++) {
        const value = row[index];
        const propertyName = columsRowsData.columns[index];
        obj[propertyName] = value;
      }
      array.push(obj);
    }
    return array;
  };

  const buscarListaInadimplencias = async filtros => {
    setErroBuscaInadimpencias(false);
    setCarregandoInadimplencias(true);
    setRegistros([]);
    try {
      const response = await api.buscarListaInadimplencias(filtros);
      const registros = toArrayObjetos(response);
      setRegistros(registros);
    } catch (err) {
      setErroBuscaInadimpencias(true);
      toast.error(err.message);
    } finally {
      setCarregandoInadimplencias(false);
    }
  };

  const mostrarDetalhesRegistro = registro => {
    setRegistroSelecionado(registro);
  };

  const onCobrancaEncaminhada = numeroPreVenda => {
    setRegistros(
      registros.map(reg => {
        if (reg.numero_pre_venda === numeroPreVenda)
          reg.status_encaminhamento = 1;
        return reg;
      })
    );
    setRegistroSelecionado(null);
  };

  const onContatoRealizado = (numeroPreVenda, data) => {
    setRegistros(
      registros.map(reg => {
        if (reg.numero_pre_venda === numeroPreVenda)
          reg.ultimo_contato_corretor = data;
        return reg;
      })
    );
  };

  return (
    <>
      <Header title="Inadimplência" />
      <FiltrosInadimplencia onSubmit={buscarListaInadimplencias} />

      <Container fluid className="mt-3">
        <Tab.Container activeKey={abaAtiva} onSelect={handleAbaChange}>
          {!(carregandoInadimplencias || isLoadingOptions) && (
            <div className="d-flex justify-content-center mb-3">
              <ButtonGroup>
                <Button
                  variant={
                    abaAtiva === 'analitico' ? 'primary' : 'outline-primary'
                  }
                  onClick={() => handleAbaChange('analitico')}
                  style={{
                    borderRadius: '8px 0 0 8px',
                    fontWeight: abaAtiva === 'analitico' ? 'bold' : 'normal',
                    minWidth: '120px',
                  }}
                >
                  Analítico
                </Button>
                <Button
                  variant={
                    abaAtiva === 'consolidado' ? 'primary' : 'outline-primary'
                  }
                  onClick={() => handleAbaChange('consolidado')}
                  style={{
                    borderRadius: '0 8px 8px 0',
                    fontWeight: abaAtiva === 'consolidado' ? 'bold' : 'normal',
                    minWidth: '120px',
                  }}
                >
                  Consolidado
                </Button>
              </ButtonGroup>
            </div>
          )}

          <Tab.Content>
            <Tab.Pane eventKey="analitico">
              {(carregandoInadimplencias || isLoadingOptions) &&
                abaAtiva === 'analitico' && <Loading label="Buscando dados" />}
              {!carregandoInadimplencias &&
                !erroBuscaInadimpencias &&
                registros.length === 0 && (
                  <Aviso
                    icon={<BsInbox fontSize={72} />}
                    text="Dados não encontrados. Tente outros filtros."
                  />
                )}
              {erroBuscaInadimpencias && (
                <Aviso
                  icon={<MdError fontSize={72} />}
                  text="Ocorreu um erro ao carregar os dados."
                />
              )}
              {registros.length > 0 && !isLoadingOptions && (
                <TabelaInadimplencia
                  registros={registros}
                  mostrarDetalhesRegistro={mostrarDetalhesRegistro}
                  empreendimentos={empreendimentos}
                />
              )}
            </Tab.Pane>

            <Tab.Pane eventKey="consolidado">
              {(carregandoInadimplencias || isLoadingOptions) &&
                abaAtiva === 'consolidado' && (
                  <Loading label="Buscando dados" />
                )}
              {!carregandoInadimplencias &&
                !erroBuscaInadimpencias &&
                registros.length === 0 && (
                  <Aviso
                    icon={<BsInbox fontSize={72} />}
                    text="Dados não encontrados. Tente outros filtros."
                  />
                )}
              {erroBuscaInadimpencias && (
                <Aviso
                  icon={<MdError fontSize={72} />}
                  text="Ocorreu um erro ao carregar os dados."
                />
              )}
              {registros.length > 0 && (
                <EstatisticasInadimplencia
                  registros={registros}
                  imobiliarias={imobiliarias}
                  corretores={corretores}
                  empreendimentos={empreendimentos}
                  isLoadingOptions={isLoadingOptions}
                />
              )}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Container>

      <ModalDetalhesClienteInadimplencias
        onCobrancaEncaminhada={onCobrancaEncaminhada}
        onContatoRealizado={onContatoRealizado}
        registro={registroSelecionado}
        onHide={() => setRegistroSelecionado(null)}
        empreendimentos={empreendimentos}
      />
    </>
  );
};

const mapStateToProps = state => ({
  isLoadingOptions: state.prospecto.isLoadingOptions,
  empreendimentos: state.empreendimentos.list,
  imobiliarias: state.corretor.listaGerentes,
  corretores: state.corretor.listaCorretores,
});

export default connect(mapStateToProps)(CobrancaInadimplencia);
